/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form/immutable';

import { Detail,SidePanelTable, DetailHeader, InputField, ToggleField, DatepickerField, SelectField } from 'cx-ui-components';
import DetailWrapper from '../../../components/DetailWrapper';
import styled from 'styled-components';
import FieldWrapper from 'cx-ui-components/src/components/ConfigUi/Field/FieldWrapper';
import { Fragment } from 'react';
import { Route ,Redirect} from 'react-router-dom';
import { entitiesMetaData } from '../../../redux/modules/entities/metaData';
import AmrPanel from '../../SidePanelDetails/Amr';
import messages from "./messages";
import { FormattedMessage } from 'react-intl';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const WrapperRow = styled.div`
  display: flex;
  flex-direction: row;
`;
const DetailsPanel = styled.div`
  position: relative;
  padding: 10px 14px;
  overflow-y: auto;
`;

const WrappedDetailHeader = styled(DetailHeader)`
  margin-left: 10px;
`;

const CheckboxLabel = styled.div`
  margin: 0px 10px 20px 10px;
  display: flex;
  font-size: 13px;
  line-height: 1.5em;
`;

const CheckboxText = styled.p`
  margin: 0px;
  font-size: 13px;
  line-height: 1.5em;
`;
const PermissionsDenied = styled.p`
  margin: 0px;
  font-size: 13px;
  line-height: 1.5em;
  color:red;
`;
const Checkbox = styled.input`
  margin-right: 10px;
  margin-top: 4px;
  transform: scale(1.2);
`;

const RequestInputField = styled(InputField)`
  display: none;
`;
const customDatePickerStyle = {
  fontSize: '16px',
  borderRadius: '3px',
  minWidth: '271px',
  height: '36px',
  boxSizing: 'border-box',
  backgroundColor: 'transparent',
  padding: '2px 35px 0 20px',
  border: '1px solid #4C4C4C',
  color: '#dadada',
  containerBackground: '#656565',
};

const tnc = (selectedRequestType) => {
  switch (selectedRequestType) {
    case 'add-lock':
      return < FormattedMessage {...messages.addLock} />
    case 'remove-lock':
      return < FormattedMessage {...messages.removeLock} />
    case 'delete':
      return < FormattedMessage {...messages.delete} />
  }
}

const getArtifactSubType = (typeHasSubtypes, isSaving, isCreatingEntity, artifactSubtypes) => {
  if (typeHasSubtypes) {
    return <SelectField
      name="requestedArtifactSubType"
      label="Artifact Subtype *"
      placeholder="Select subtype..."
      data-automation="artifactSubtypeList"
      disabled={isSaving || !isCreatingEntity}
      options={[
        {
          label: 'Select subtype...',
          value: '',
        },
        ...artifactSubtypes,
      ]}
      required
    />
  } else {
    return <></>
  }
}
export default function AmrForm({
  initialValues,
  handleSubmit,
  isSaving,
  artifactTypes,
  requestTypeList,
  submittedValues,
  actionTypes,
  artifactSubtypes,
  selectableVersions,
  userHasUpdatePermission,
  removeLockPermission,
  isCreatingEntity,
  typeHasSubtypes,
  key,
  selectedRequestType,
  sidePanelData,
  statusRequestDetails,
  artifactFilesDeleted,
  artifactFailedLocked,
  artifactsProcessedCount,
  interactionsProcessedCount,
  interactionsRemainingCount,
  errorCount,
}) {
  if (Object.keys(submittedValues).length == 0) {
    return (
      <form onSubmit={(e) => {e.preventDefault(); handleSubmit}} key={key}>
        <Wrapper>

          <WrappedDetailHeader text="Request Details" />
          <RequestInputField
            name="requestId"
            label=""
            id="frm-groups-description"
            data-automation="descriptionInput"
            componentType="textarea"
            inputType="text"
           // disabled={isSaving || !isCreatingEntity}
          />
          <InputField
            name="description"
            label="Description"
            id="frm-groups-description"
            data-automation="descriptionInput"
            componentType="textarea"
            inputType="text"
            disabled={isSaving || !isCreatingEntity}
          />
          <SelectField
            name="requestType"
            label="Request Type *"
            placeholder="Select type of request"
            data-automation="requestTypeList"
            disabled={isSaving || !isCreatingEntity}
            options={[
              {
                label: 'Select type...',
                value: '',
              },
              ...requestTypeList,
            ]}
            required
          />
          {selectedRequestType == "delete" &&
            (<Fragment><WrapperRow><ToggleField
              id="frm-delete-default"
              name="removeLock"
              label="Remove Locks to Process Request"
              disabled={!removeLockPermission}
              data-automation="isDefaultToggle"
            /> {removeLockPermission == false && <PermissionsDenied>(Permissions denied to enable the Remove Locks to Process Request)</PermissionsDenied>}</WrapperRow></Fragment>)}
          {selectedRequestType !== undefined && (
            <Field
              name="tncAccepted"
              type="checkbox"
              labelChildren={tnc(selectedRequestType)}
              normalize={(value) => value === true}
              component={({ labelChildren, input }) => (
                <CheckboxLabel>
                  <Checkbox {...input} type="checkbox" required={true} />
                  <CheckboxText>{labelChildren}</CheckboxText>
                </CheckboxLabel>
              )}
              required={true}
            />)}
          {selectedRequestType == "add-lock" &&
            (<Fragment><ToggleField
              id="frm-reason-list-is-default"
              name="lockExpires"
              label="Lock Expires"
              title="Assigns list to all users on tenant"
           //   onChange={() => { }}
              //  disabled={isSaving || inherited || !userHasUpdatePermission}
              data-automation="isDefaultToggle"
            />
              <DatepickerField
                name="lockExpiryDate"
                label="Lock Expires On *"
                data-automation="dateDatePicker"
                minDate={ new Date(new Date().setDate(new Date().getDate()+1))}
                placeholder={' '}     
              />

            </Fragment>)}
        </Wrapper>
        <Wrapper>
          <WrappedDetailHeader text="Artifact Type" />
          <SelectField
            name="requestedArtifactTypeId"
            label="Artifact Type *"
            placeholder="Select type..."
            data-automation="artifactTypeList"
            disabled={isSaving || !isCreatingEntity}
            options={[
              {
                label: 'Select type...',
                value: '',
              },
              ...artifactTypes,
            ]}
            required
          />
          {typeHasSubtypes && (
            <SelectField
              name="requestedArtifactSubType"
              label="Artifact Subtype *"
              placeholder="Select subtype..."
              data-automation="artifactSubtypeList"
              disabled={isSaving || !isCreatingEntity}
              options={[
                {
                  label: 'Select subtype...',
                  value: '',
                },
                ...artifactSubtypes,
              ]}
              required
            />
          )}
        </Wrapper>
        <Wrapper>
          <WrappedDetailHeader text="Interaction Ids" />
          <InputField
            name="interactionIds"
            label="Interaction Ids * (Please enter valid interaction Id's separated by comma)"
            id="frm-"
            data-automation="descriptionInput"
            componentType="textarea"
            inputType="text"
            disabled={isSaving || !isCreatingEntity}
          />

        </Wrapper>
      </form>
    )
  } else {
    return (
      <form key={"displayForm"}>
      <Wrapper>
        <DetailWrapper open data-automation="amrSideRequestStatusSVG">
          <WrappedDetailHeader text="Request Status" />
          <WrapperRow>
            <Wrapper>
              <Detail
                label="Status"
                value={statusRequestDetails}
              />
              <Detail
                label="Errors"
                value={errorCount}
              />
              <Detail
                label="Interactions Processed"
                value={interactionsProcessedCount}
              />
              <Detail
                label="Interactions Remaining"
                value={interactionsRemainingCount}
              />
            </Wrapper>
            <Wrapper></Wrapper>
            <Wrapper>
              <Detail
                label="Artifact Processed"
                value={artifactsProcessedCount}
              />
              <Detail
                label="Artifacts Failed - Deleted"
                value={artifactFilesDeleted}
              />
              <Detail
                label="Artifacts Failed - Locked"
                value={artifactFailedLocked}
              />
            </Wrapper>
          </WrapperRow>
          <SidePanelTable
            tableType={'sidePanel'}
            items={sidePanelData}
            fields={entitiesMetaData.amr.membersTableFields['view']}
            defaultSorted={[{ id: 'interactionId', desc: true }]}
          />
        </DetailWrapper>


        <DetailWrapper open data-automation="amrSideRequestDetailsSVG">
          <WrappedDetailHeader text="Request Details" />
          <InputField
            name="description"
            label="Description"
            id="frm-groups-description"
            data-automation="descriptionInput"
            componentType="textarea"
            inputType="text"
            disabled={true}
          />
          <InputField
            name="requestType"
            label="Request Type"
            id="frm-groups-description"
            data-automation="requestTypeInput"
            componentType="input"
            inputType="text"
            disabled={true}
          />
          <ToggleField
            id="frm-delete-default"
            name="removeLock"
            label="Remove Locks to Process Request"
        //    onChange={() => { }}
            disabled={true}
            data-automation="isDefaultToggle"
          />
          <Field
            name="tncAccepted"
            type="checkbox"
            labelChildren={"I understand it may take up to 12-hours to move artifacts from long-term storage to active storage and there is an Archive Storage Retrieval cost per GB in a calendar month."}
            normalize={(value) => value === true}
            component={({ labelChildren, input }) => (
              <CheckboxLabel>
                <Checkbox {...input} type="checkbox" required={true} />
                <CheckboxText>{labelChildren}</CheckboxText>
              </CheckboxLabel>
            )}
            required={true}
          />
          <Field
            name="tncAccepted"
            type="checkbox"
            labelChildren={"I acknowledge artifacts kept in Active Storage are subject to Fair Use Active Data Storage limits and may result in Active Storage Usage Overage cost per GB in a calendar month."}
            normalize={(value) => value === true}
            component={({ labelChildren, input }) => (
              <CheckboxLabel>
                <Checkbox {...input} type="checkbox" required={true} />
                <CheckboxText>{labelChildren}</CheckboxText>
              </CheckboxLabel>
            )}
            required={true}
          />
        </DetailWrapper>

        <DetailWrapper open data-automation="amrSideArtifactTypeSVG">
          <WrappedDetailHeader text="Artifact Type" />
          <SelectField
            name="artifactType"
            label="Artifact Type*"
            placeholder="Select subtype..."
            data-automation="artifactSubtypeList"
            disabled={true}
            options={[
              {
                label: 'Select subtype...',
                value: '',
              },
              ...artifactSubtypes,
            ]}
            required
          />
        </DetailWrapper>
      </Wrapper>
    </form>
    )
  }
}

AmrForm.propTypes = {
  key: PropTypes.string,
  actionTypes: PropTypes.array,
  artifactTypes: PropTypes.array,
  requestType: PropTypes.array,
  artifactSubtypes: PropTypes.array,
  currentFormValues: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  isCreatingEntity: PropTypes.bool,
  userHasUpdatePermission: PropTypes.bool,
};
